// extracted by mini-css-extract-plugin
export default {"container":"TNC_container__ogzCD"};